<template>
    <b-modal id="modal-disclaimer"
             centered
             size="lg"
             title="IMPORTANT!"
             v-model="show"
             :no-close-on-backdrop="true"
             :no-close-on-esc="true"
             header-text-variant="danger"
             body-bg-variant="secondary">
        <template v-slot:modal-header="{ close }">
            <div class="mx-2 text-lg text-danger font-weight-bold">
                IMPORTANT!
            </div>
        </template>
        <p class="m-2 text-md text-dark">
            <span>
                When you need to find the right replacement for an existing Bradford White model or for another manufacturer's model, the RightSpec<sup>&reg;</sup> Cross-Reference Guide is the place to start. Simply choose the brand and then the model number you are replacing. The cross reference tool will automatically display the appropriate Bradford White model along with side-by-side specifications.
            </span>
            <span class="text-danger text-uppercase font-weight-bold">
                Please be aware that both Bradford White and our competitor's model specifications and dimensions are subject to change without notice. All changes may not be accounted for in the RightSpec<sup>&reg;</sup> Cross Reference Guide.
            </span>
            <span class="">
                Please click ACCEPT to continue to the RightSpec<sup>&reg;</sup> Cross Reference Guide
            </span>
        </p>

        <template v-slot:modal-footer="{ ok }">

            <b-button variant="primary" @click="acceptCookie()" class="font-weight-bold">
                ACCEPT
            </b-button>
        </template>
    </b-modal>
</template>
<script>
    export default {
        name: 'modal-disclaimer',        
        methods: {
            acceptCookie() {
                this.$cookies.set('accept', true, "1d")
                this.show = false
            },
        },
        data() {
            return {
                show: false
            }
        },
        created() {
            this.show = true
            var acceptCookie = this.$cookies.get('accept')
            if (acceptCookie)
                this.show = !acceptCookie
            else
                this.show = true

        },
    }
</script>
